declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '901428096060438'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  // Manual Facebook Pixel initialization (same as their snippet, but safe for all environments)
  const f = window as any
  const b = document
  if (f.fbq) return
  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  // Safely inject the fbevents.js script
  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    // Fallback: append to head or documentElement
    ;(b.head || b.documentElement).appendChild(t)
  }

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackInitiateCheckout() {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }
}
